export default __webpack_public_path__ + "7fae787e0d203c37dbbd95e3c46b87dc.png";